import { SelectImages as SelectImagesStep } from 'components/Wizards/SelectImages/SelectImages'
import { Values } from 'components/Wizards/MultiStepBlogPostWizard/Types'
import { multiStep } from 'components/Wizards/MultiStepWizard/multiStep'
import { StepProps } from 'components/Wizards/MultiStepWizard/Types'

export const SelectImages = multiStep(
  ({ onSubmit, doNotIncludeImagesDefault, ...stepProps }: StepProps & { doNotIncludeImagesDefault?: boolean }) => {
    const handleSubmit = (values: Values) => {
      return onSubmit({ ...values })
    }

    return (
      <SelectImagesStep {...stepProps} onSubmit={handleSubmit} doNotIncludeImagesDefault={doNotIncludeImagesDefault} />
    )
  },
)
